import React from "react";

export default function Die(props) {
  const styles = {
    backgroundColor: props.isHeld ? "#59E391" : "transparent"
  };
  return (
    <div onClick={props.holdDice} style={styles} className = {`die-face die-value${props.value}`}>
      <h2 className="die-num">{props.value}</h2>
    </div>
  );
}
